<div class="ion-text-center">
  <ion-text color="medium">
    <small>{{appInformationService.name}} {{appInformationService.version}}</small>
    <br>
    <small>© {{appInformationService.author}} {{appInformationService.date | date:'yyyy':undefined:this.languageService.selectedLanguage?.locale}}</small>
  </ion-text>
</div>
